export const environment = {
  production: true,
  apiUrl: 'https://payment-api-api-test.vandersangen.dev/api',
  staticApiUrl: 'https://project-template-api.vandersangen.dev/api'
};
